import commaNumber from 'comma-number'

import { CURRENCY_DELIMITER } from '../constants/app'

const formatTicks = (num) => {
  if (num === undefined) {
    return ''
  }
  return commaNumber(num, CURRENCY_DELIMITER)
}

const toLowerCamelCase = (s) => {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace('-', '').replace('_', '')
  })
}

const trim = (string) => {
  return string ? string.trim() : ''
}

const removeNumbersFromString = (input) => {
  return input?.replace(/\d+/g, '')
}

export { formatTicks, toLowerCamelCase, trim, removeNumbersFromString }
